export const SET_LOADING = 'src/store/sponsorship/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/sponsorship/SET_SAVE_LOADING'
export const SET_LEAGUE_SPONSORSHIP = 'src/store/sponsorship/SET_LEAGUE_SPONSORSHIP'
export const SET_MATCH_SPONSORSHIP = 'src/store/sponsorship/SET_MATCH_SPONSORSHIP'
export const SET_SPONSORSHIP_RESPONSE = 'src/store/sponsorship/SET_SPONSORSHIP_RESPONSE'
